import React, {Component} from 'react';
import Translator         from "../../components/Translator";

class ErrorHandler extends Component
{
    getErrorContent()
    {
        let translator = <Translator content="messages.errors.errorTitle" />;

        const customTitle = this.props.customMessage?.title ?? '';
        if (this.props.errorMessage === 'address.errors.toEarly' && customTitle === '') {
            translator = <Translator content="messages.errors.errorTitles.toEarly" />;
        }

        return <div className="error-message">
            <h5>
                <i className="icon icon-stayery-exclude" />
                {customTitle !== '' ? customTitle : translator}
            </h5>
            {(this.props.customMessage?.body ?? '') !== '' ? (this.props.customMessage?.body ?? '') : <Translator
                content={this.props.errorMessage} />}
        </div>;
    }

    getWarningContent()
    {
        return <div className="warning-message">
            <i className="icon icon-stayery-exclude" />
            <Translator content={'messages.timeout'} />
        </div>;
    }

    render()
    {
        return (this.props.messageType === 'warning') ? this.getWarningContent() : this.getErrorContent();
    }
}

export default ErrorHandler;
